import { APP_CUSTOM_URL_SCHEME_DEEPLINK, APP_CUSTOM_URL_SCHEME_DEEPLINK_HOST } from './capacitor.constants';

export const generateDeeplink = (path: string) => {
  const normalizedPath = path.startsWith('/') ? path.slice(1) : path;

  return `${APP_CUSTOM_URL_SCHEME_DEEPLINK}://${APP_CUSTOM_URL_SCHEME_DEEPLINK_HOST}/${normalizedPath}`;
};
